(function () {
  var docEl = document.documentElement;
  if (!docEl.classList.contains('zenith-show-intro')) return;

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('zenith-intro');
    if (!overlay) {
      docEl.classList.remove('zenith-show-intro');
      return;
    }

    var holdMs = parseInt(getComputedStyle(docEl).getPropertyValue('--intro-hold-ms'), 10) || 2000;
    var fadeInMs = 250;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-active');
      });
    });

    window.setTimeout(function () {
      overlay.classList.add('is-leaving');
    }, holdMs + fadeInMs);

    overlay.addEventListener('transitionend', function handleEnd(event) {
      if (event.propertyName !== 'opacity') return;
      overlay.removeEventListener('transitionend', handleEnd);
      docEl.classList.remove('zenith-show-intro');
      overlay.setAttribute('aria-hidden', 'true');
    });
  });
})();
